/**
 * Role Definitions for Multi-Tenant System
 * ServiceHive Platform Roles and Tenant Roles
 */

// Platform-level roles (ServiceHive staff)
export const PLATFORM_ROLES = {
  SUPER_ADMIN: 'super_admin',
  PLATFORM_ADMIN: 'platform_admin',
  PLATFORM_SUPPORT: 'platform_support',
};

// Tenant-level roles (Client users)
export const TENANT_ROLES = {
  TENANT_OWNER: 'tenant_owner',
  TENANT_ADMIN: 'tenant_admin',
  TENANT_OPS: 'tenant_ops',
  TENANT_USER: 'tenant_user',
  TENANT_VIEWER: 'tenant_viewer',
};

// All roles combined
export const ROLES = {
  ...PLATFORM_ROLES,
  ...TENANT_ROLES,
};

// Role hierarchy (higher number = more permissions)
export const ROLE_HIERARCHY = {
  [ROLES.SUPER_ADMIN]: 100,
  [ROLES.PLATFORM_ADMIN]: 90,
  [ROLES.PLATFORM_SUPPORT]: 80,
  [ROLES.TENANT_OWNER]: 50,
  [ROLES.TENANT_ADMIN]: 40,
  [ROLES.TENANT_OPS]: 30,
  [ROLES.TENANT_USER]: 20,
  [ROLES.TENANT_VIEWER]: 10,
};

// Check if role is a platform role
export const isPlatformRole = (role) => Object.values(PLATFORM_ROLES).includes(role);

// Check if role is a tenant role
export const isTenantRole = (role) => Object.values(TENANT_ROLES).includes(role);

// Get role display name
export const ROLE_DISPLAY_NAMES = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.PLATFORM_ADMIN]: 'Platform Admin',
  [ROLES.PLATFORM_SUPPORT]: 'Support Staff',
  [ROLES.TENANT_OWNER]: 'Owner',
  [ROLES.TENANT_ADMIN]: 'Administrator',
  [ROLES.TENANT_OPS]: 'Operations Manager',
  [ROLES.TENANT_USER]: 'User',
  [ROLES.TENANT_VIEWER]: 'Viewer',
};

// Role colors for UI
export const ROLE_COLORS = {
  [ROLES.SUPER_ADMIN]: 'purple',
  [ROLES.PLATFORM_ADMIN]: 'indigo',
  [ROLES.PLATFORM_SUPPORT]: 'blue',
  [ROLES.TENANT_OWNER]: 'emerald',
  [ROLES.TENANT_ADMIN]: 'green',
  [ROLES.TENANT_OPS]: 'yellow',
  [ROLES.TENANT_USER]: 'gray',
  [ROLES.TENANT_VIEWER]: 'slate',
};

export default ROLES;

